// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Error_pageWrapper__JqIni","result":"Error_result__RgQJ5"};